import { useMemo } from 'react';

import isEmpty from 'lodash-es/isEmpty';

import { Custom_Preset } from '@bo-ibSheet/common';

export const ENT_MEAN_CODE = {
  PIN: '10',
  EMAIL: '20',
  PIN_EMAIL: '30',
  COUPON: '50',
};

export const useEntryMeanValidators = ({ entryMeanCode, subsidiaryCodeList, gridRef }) => {
  return useMemo(
    () => ({
      getInitialAccumulator: () => ({}),
      certMethodCode: [
        {
          when: ['created', 'updated'],
          message: '인증형식을 입력해 주세요.',
          validator: ({ certMethodCode }) => !isEmpty(certMethodCode),
        },
        {
          when: ['created', 'updated'],
          message: '정확한 값을 입력해 주세요.',
          validator: ({ certMethodCode }) => {
            switch (entryMeanCode) {
              case ENT_MEAN_CODE.PIN:
                return certMethodCode === 'P';
              case ENT_MEAN_CODE.EMAIL:
                return certMethodCode === 'M';
                case ENT_MEAN_CODE.COUPON:
                  return certMethodCode === 'C';
              default:
                return true;
            }
          },
        },
      ],
      certInfo: [
        {
          when: ['created', 'updated'],
          message: '인증값을 입력해 주세요.',
          validator: ({ certInfo }) => !isEmpty(certInfo),
        },
        {
          when: ['created', 'updated'],
          message: '중복된 인증값이 존재합니다.',
          validator: ({ certInfo }) => {
            const certInfoList = gridRef.current.getDataRows().map(({ certInfo }) => certInfo);

            return certInfoList.filter((cert) => cert === certInfo).length <= 1;
          },
        },
      ],
      subsidiaryCode: [
        {
          when: ['created', 'updated'],
          message: '계열사번호를 입력해 주세요.',
          validator: ({ subsidiaryCode }) => !isEmpty(subsidiaryCode),
        },
        {
          when: ['created', 'updated'],
          message: '등록된 계열사번호를 입력해 주세요.',
          validator: ({ subsidiaryCode }) => subsidiaryCodeList.includes(subsidiaryCode),
        },
      ],
      memberNumber: [
        {
          when: ['created', 'updated'],
          message: '이메일 인증에서는 회원번호가 필요하지 않습니다.',
          validator: ({ certMethodCode, memberNumber }) => {
            if (certMethodCode === 'M') return isEmpty(memberNumber);
            else return true;
          },
        },
      ],
    }),
    [entryMeanCode, subsidiaryCodeList, gridRef]
  );
};

export const useGridOptions = ({ entryMeanCode }) => {
  return useMemo(
    () => ({
      Def: {
        Row: {
          Height: 44,
          CanFormula: 1,
          CalcOrder: 'certMethodCodeEnum,certMethodCodeEnumKeys',
        },
      },
      Cols: [
        { ...Custom_Preset.RowIndex },
        {
          Header: '인증형식',
          Type: 'Enum',
          Name: 'certMethodCode',
          Key: 'CERT_METHOD_CD',
          MinWidth: 150,
          Enum: '|코드|이메일|프로모션',
          EnumKeys: '|P|M|C',
          EnumFormula: () => {
            switch (entryMeanCode) {
              case ENT_MEAN_CODE.PIN:
                return '|코드';
              case ENT_MEAN_CODE.EMAIL:
                return '|이메일';
                case ENT_MEAN_CODE.COUPON:
                  return '|프로모션';
              default:
                return '|코드|이메일|프로모션';
            }
          },
          EnumKeysFormula: () => {
            switch (entryMeanCode) {
              case ENT_MEAN_CODE.PIN:
                return '|P';
              case ENT_MEAN_CODE.EMAIL:
                return '|M';
                case ENT_MEAN_CODE.COUPON:
                  return '|C';
              default:
                return '|P|M|C';
            }
          },
          Required: 1,
        },
        {
          Header: '인증값',
          Type: 'Text',
          Name: 'certInfo',
          Key: 'CERT_INFO',
          MinWidth: 150,
          Required: 1,
        },
        {
          Header: '회원번호',
          Type: 'Text',
          Name: 'memberNumber',
          Key: 'MBR_NO',
          MinWidth: 150,
        },
        {
          Header: '계열사번호',
          Type: 'Text',
          Name: 'subsidiaryCode',
          Key: 'SBCOM_CD',
          MinWidth: 150,
          Required: 1,
        },
        {
          Header: '멤버인증번호',
          Type: 'Text',
          Name: 'memberCertInfoNo',
          Visible: 0,
          CanExport: 0,
        },
        {
          Header: '사이트번호',
          Type: 'Text',
          Name: 'siteNumber',
          Visible: 0,
          CanExport: 0,
        },
        Custom_Preset.ErrorDescription,
      ],
    }),
    [entryMeanCode]
  );
};
